"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var styles_module_scss_1 = __importDefault(require("../../styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var onChangeHandler_1 = require("./onChangeHandler");
var onKeyDownHandler_1 = require("./onKeyDownHandler");
var EndTimeInput = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement(react_final_form_1.Field, { name: "endTime", render: function (_a) {
            var input = _a.input;
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, t('endTimeOfTheBlock')),
                react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { onChange: function (e) {
                        var newEvent = (0, onChangeHandler_1.onChangeHandler)(e);
                        input.onChange(newEvent);
                    }, onKeyDown: onKeyDownHandler_1.onKeyDownHandler, placeholder: "00:00", mask: "__:__", maxLength: 5 }))));
        } }));
};
exports.default = EndTimeInput;
